import { useQuery } from "@apollo/client/react";
import { gql } from "@apollo/client";

export const DOCUMENTS_QUERY = gql`
  query Documents($projectId: ID!) {
    documents(projectId: $projectId) {
      id
      title
      description
      documentType
      visibility
      filename
      url
      contentType
      size
      uploadedBy {
        id
        fullName
      }
      uploadedAt
      createdAt
    }
  }
`;

export interface UseDocumentsOptions {
  projectId: string;
}

export function useDocuments({ projectId }: UseDocumentsOptions) {
  const { data, loading, error, refetch } = useQuery(DOCUMENTS_QUERY, {
    variables: { projectId },
    skip: !projectId,
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: false,
  });

  const documents =
    (data as { documents?: Array<Record<string, unknown>> })?.documents ?? [];

  return { documents, loading, error, refetch };
}
